import { createSlice } from "@reduxjs/toolkit";
import { LocatorReducerType } from "../../types/LocatorTypes";

const initialState: LocatorReducerType = {
  // Locator lengths & types related
  locatorFetchStatus: "idle",
  locatorLengths: null,
  locatorTypes: null,
  locatorData: null,

  // Uploading locator image
  locatorUploadStatus: "idle",
  uploadedLocatorData: null,

  // Adding locator to dataset
  addNewLocatorStatus: "idle",
  newLocatorData: null,

  // Selecting a locator from the grid
  activeLocator: null,

  // Update Existing locator
  locatorUpdateStatus: "idle",

  // Filtering conditions
  locatorFilters: {
    imagetype: "undefined",
    typeid: "undefined",
    lengthid: "undefined",
  },

  locatorsTotalAmount: 0,
};

const LocatorSlice = createSlice({
  name: "LocatorReducer",
  initialState,
  reducers: {
    updateLocatorFetchStatus: (nextState, { payload }) => {
      nextState.locatorFetchStatus = payload;
    },
    updateLocatorLengths: (nextState, { payload }) => {
      nextState.locatorLengths = payload;
    },
    updateLocatorTypes: (nextState, { payload }) => {
      nextState.locatorTypes = payload;
    },
    updateLocatorData: (nextState, { payload }) => {
      nextState.locatorData = payload;
    },

    // Uploading locator image
    updateLocatorUploadStatus: (nextState, { payload }) => {
      nextState.locatorUploadStatus = payload;
    },
    updateUploadedLocatorData: (nextState, { payload }) => {
      nextState.uploadedLocatorData = payload;
    },

    // Adding locator to dataset
    updateAddLocatorStatus: (nextState, { payload }) => {
      nextState.addNewLocatorStatus = payload;
    },
    updateNewLocatorData: (nextState, { payload }) => {
      nextState.newLocatorData = payload;
    },

    // =====
    updateActiveLocator: (nextState, { payload }) => {
      nextState.activeLocator = payload;
      nextState.locatorUpdateStatus = "idle";
    },

    setLocatorUpdateStatus: (nextState, { payload }) => {
      nextState.locatorUpdateStatus = payload;
    },

    // Locators filtering
    updateLocatorFilters: (nextState, { payload }) => {
      nextState.locatorFilters = payload;
      nextState.activeLocator = null;
    },

    resetLocatorUpload: (nextState) => {
      nextState.locatorUploadStatus = "idle";
      nextState.uploadedLocatorData = null;
      nextState.addNewLocatorStatus = "idle";
      nextState.newLocatorData = null;
    },

    updateLocatorTotalAmount: (nextState, { payload }) => {
      nextState.locatorsTotalAmount = payload;
    },

    // Reset state
    resetLocatorSlice: (nextState) => {
      Object.keys(initialState).map(
        (key) =>
          (nextState[key as keyof typeof initialState] =
            initialState[key as keyof typeof initialState])
      );
    },
  },
});

export const { reducer: LocatorReducer } = LocatorSlice;
export const {
  updateLocatorFetchStatus,
  updateLocatorLengths,
  updateLocatorTypes,
  updateLocatorData,
  updateLocatorUploadStatus,
  updateUploadedLocatorData,
  updateAddLocatorStatus,
  updateNewLocatorData,
  updateActiveLocator,
  resetLocatorUpload,
  resetLocatorSlice,
  updateLocatorFilters,
  updateLocatorTotalAmount,
  setLocatorUpdateStatus,
} = LocatorSlice.actions;
